module.exports = __webpack_public_path__ + "manual-deleteBtn.png?bb2b03f5ae83beee3210397b26f898ef";


//////////////////
// WEBPACK FOOTER
// ./src/images/manual-deleteBtn.png
// module id = 402
// module chunks = 0